export default "__VITE_ASSET__CixVlVwn__"